module.exports = __webpack_public_path__ + "img/feature_buy_th.525727ba.png";